@if (user()) {
  <!--Currently unmaintainable -->
  <!--<hub-ai-assistant-button class="hub-mr-1"></hub-ai-assistant-button>-->
  <hub-operation-toasts />

  @if (mode() === applicationMode.hub && isDesignerAssistantEnabled()) {
    <hub-button
      type="iconPrimary"
      icon="icon-ai"
      iconSize="large"
      ariaLabel="Designer Assistant"
      ngbTooltip="Designer Assistant"
      (clicked)="toggleDesignerAssistant()" />
  }

  <hub-button
    type="link"
    customClass="hub-fs-14 hub-text-lighter hub-p-0 hub-fw-500"
    icon="icon-unknown hub-mr-0-25 hub-text-white hub-rounded-circle hub-bg-muted"
    [externalLink]="docsUrl"
    >Help
  </hub-button>

  @if (!isLicensePortal() && !IS_LITE) {
    <hub-main-header-notifications />
  }
}
